package components.company.pricelist.tables

import components.company.pricelist.dataSheetLink
import it.neckar.lizergy.model.configuration.quote.builder.Manufacturer
import it.neckar.lizergy.model.financial.currency.PriceWithProfit
import it.neckar.lizergy.model.financial.currency.PriceWithProfitAndWorkingTime
import it.neckar.open.kotlin.lang.ifNull
import it.neckar.open.time.formatHourAndMinutes
import kotlinx.html.TBODY
import kotlinx.html.ThScope
import react.*
import react.dom.*
import store.hooks.useSelectPriceList

val MiscellaneousPriceTable: FC<Props> = fc("MiscellaneousPriceTable") {
  val priceList = useSelectPriceList()


  div("col") {
    h2 {
      +"Sonstiges"
    }

    table("table table-responsive table-striped") {
      thead {
        tr {
          th(ThScope.col) {
            +"#"
          }
          th(ThScope.col) {
            +"Name"
          }
          th(ThScope.col) {
          }
          th(ThScope.col, "text-end") {
            +"Kosten"
          }
          th(ThScope.col, "text-end") {
            +"Preis"
          }

          th(ThScope.col) { }
        }
      }

      tbody {
        var rowIndex = 1

        rowIndex += addRow(rowIndex, "Baustelleneinrichtung", priceList.sitePreparation)
        rowIndex += addRow(rowIndex, "Preis pro gefahrenem km", priceList.perKilometerTravelled)
        rowIndex += addRow(rowIndex, "Aufpreis verstärktes Schienensystem (pro Modul)", priceList.aufpreisSchienensystemPrice)
        rowIndex += addRow(rowIndex, "Aufpreis schwarze Klemmen (pro Modul)", priceList.aufpreisSchwarzeKlemmePrice)
        rowIndex += addRow(rowIndex, "Integration PV Anlage in äußeren Blitzschutz", priceList.blitzschutzIntegrieren)
        rowIndex += addRow(rowIndex, "Gerüst pro m²", priceList.scaffolding)
        rowIndex += addRow(rowIndex, "Dachständerisolierung", priceList.dachStaenderIsolierung)
        rowIndex += addRow(rowIndex, "Überspannungsschutz DC", priceList.ueberSpannungsSchutz)
        rowIndex += addRow(rowIndex, "Überspannungsschutz AC", priceList.ueberSpannungsSchutzAC)
        rowIndex += addRow(rowIndex, "Überspannungsschutz AC mit äußerem Blitzschutz", priceList.ueberSpannungsSchutzACMitBlitzschutz)
        rowIndex += addRow(rowIndex, "Satellitenantenne ummontieren", priceList.moveSatelliteDish)
        rowIndex += addRow(rowIndex, "Antenne entfernen", priceList.removeAntenna)
        rowIndex += addRow(rowIndex, "Wechselrichter in Netzwerk integrieren", priceList.integrateInverterIntoNetwork)
        rowIndex += addRow(rowIndex, "Optimierer", priceList.optimizerPrice)
        rowIndex += addRow(rowIndex, "Zuschlag Kabelweg (pro m)", priceList.zuschlagKabelweg)
        rowIndex += addRow(rowIndex, "Aufschlag Kreuzverbund (pro Modul)", priceList.aufschlagKreuzverbund)
        rowIndex += addRow(rowIndex, "Elektrische Inbetriebnahme", priceList.startingUpPrice)
        rowIndex += addRow(rowIndex, "Sunny Home Manager 2.0 Energiemanagementsystem", priceList.homeManagers[Manufacturer.SMA], priceList.homeManagerDataSheetPaths[Manufacturer.SMA])
        rowIndex += addRow(rowIndex, "Sunny Home Manager 2.0 Zubehör", priceList.homeManagerExtras[Manufacturer.SMA])
        rowIndex += addRow(rowIndex, "IBC HomeOne Hub BT-RE1 Energiemanagementsystem", priceList.homeManagers[Manufacturer.IBC], priceList.homeManagerDataSheetPaths[Manufacturer.IBC])
        rowIndex += addRow(rowIndex, "IBC HomeOne Hub BT-RE1 Zubehör", priceList.homeManagerExtras[Manufacturer.IBC])
        rowIndex += addRow(rowIndex, "Wärmepumpenanbindung", priceList.waermepumpenanbindung)
        rowIndex += addRow(rowIndex, "SMA Energy Meter ", priceList.smaEnergyMeter, priceList.smaEnergyMeterDataSheetPath)
        rowIndex += addRow(rowIndex, "Erdspieß setzen", priceList.erdspiessSetzen)
        rowIndex += addRow(rowIndex, "SLS nachrüsten", priceList.slsNachruesten)
        rowIndex += addRow(rowIndex, "Neuer Zählerschrank EFH Grober Schätzpreis, Abrechnung nach tatsächlichem Aufwand", priceList.neuerZaehlerschrank)
        rowIndex += addRow(rowIndex, "§14a EnWG Integration in Zählerschrank", priceList.enwg14aIntegrationInZaehlerschrank)
        rowIndex += addRow(rowIndex, "§14a EnWG Integration in einem separaten Aufputzgehäuse", priceList.enwg14aIntegrationInAufputzgehaeuse)
        rowIndex += addRow(rowIndex, "Zähler zusammenlegen", priceList.zaehlerschrankZusammenlegen)
        rowIndex += addRow(rowIndex, "Einbau Unterverteiler", priceList.einbauUnterverteiler)
        rowIndex += addRow(rowIndex, "Einbau digitaler Zähler", priceList.einbauDigitalerZaehlerPrice)
        rowIndex += addRow(rowIndex, "Überspannungsschutz DC", priceList.ueberSpannungsSchutz)
        rowIndex += addRow(rowIndex, "Überspannungsschutz DC Typ 1 & Typ 2", priceList.ueberSpannungsSchutzaWennExternerBlitzschutzVorhanden)
      }
    }
  }
}

private fun RDOMBuilder<TBODY>.addRow(rowIndex: Int, label: String, priceWithProfit: PriceWithProfit, dataSheetPath: String? = null): Int {
  tr {
    th(ThScope.row) {
      +"$rowIndex"
    }

    td {
      +label
    }

    td {}

    td("text-end") {
      +priceWithProfit.inputPrice.format().ifNull("-")
    }
    td("text-end") {
      +priceWithProfit.sellingPrice.format().ifNull("-")
    }

    td("text-center") {
      dataSheetPath?.let { dataSheetLink(it) }
    }
  }

  return 1
}

private fun RDOMBuilder<TBODY>.addRow(rowIndex: Int, label: String, priceWithProfitAndWorkingTime: PriceWithProfitAndWorkingTime, dataSheetPath: String? = null): Int {
  tr {
    th(ThScope.row) {
      +"$rowIndex"
    }

    td {
      +label
    }

    td {}

    td("text-end") {
      +priceWithProfitAndWorkingTime.materialPrice.inputPrice.format().ifNull("-")
    }
    td("text-end") {
      +priceWithProfitAndWorkingTime.materialPrice.sellingPrice.format().ifNull("-")
    }

    td("text-center") {}
  }

  tr {
    th(ThScope.row) {
    }

    td {
      +"Arbeitszeit:"
    }

    td("text-end") {
      +priceWithProfitAndWorkingTime.workingTimes.workingTime.formatHourAndMinutes().ifNull("-")
    }

    td("text-end") {
      +priceWithProfitAndWorkingTime.workingTimes.priceWithProfit.inputPrice.format().ifNull("-")
    }
    td("text-end") {
      +priceWithProfitAndWorkingTime.workingTimes.priceWithProfit.sellingPrice.format().ifNull("-")
    }

    td("text-center") {}
  }

  tr {
    th(ThScope.row) {
    }

    td {
      b { +"Gesamt:" }
    }

    td("text-end") {
    }

    td("text-end") {
      b { +priceWithProfitAndWorkingTime.inputPrice.format().ifNull("-") }
    }
    td("text-end") {
      b { +priceWithProfitAndWorkingTime.sellingPrice.format().ifNull("-") }
    }

    td("text-center") {
      dataSheetPath?.let { dataSheetLink(it) }
    }
  }

  return 1
}
